function iife(fn, ...args) {
    return fn(...args);
}
export { iife };

//# sourceMappingURL=no-topic.js.map